export default{name:"notification",computed:{isVisible:function isVisible(){return this.$store.state.notificationIsVisible},message:function message(){return this.$store.state.notificationMessage}}};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./app/components/elements/Notification.vue
// module id = 262
// module chunks = 0